export default {
	countryCode: "Código do país",
};
